import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  Heading,
  Text,
  Stack,
  Badge,
  Flex,
  Spinner,
} from '@chakra-ui/react'

function ModalStatus({ isOpen, onClose, statusData, isLoading }) {
  if (!statusData && !isLoading) return null

  const cadastrados = statusData?.cadastrados || {}
  const naoCadastrados = statusData?.nao_cadastrados || {}
  const totais = statusData?.total || { cadastrados: 0, nao_cadastrados: 0 }

  const fornecedores = [
    {
      id: 'xbz',
      nome: 'XBZ',
      cadastrados: parseInt(cadastrados.xbz || 0),
      nao_cadastrados: parseInt(naoCadastrados.xbz || 0),
    },
    {
      id: 'spot',
      nome: 'Spot',
      cadastrados: parseInt(cadastrados.spot || 0),
      nao_cadastrados: parseInt(naoCadastrados.spot || 0),
    },
    {
      id: 'asia',
      nome: 'Asia',
      cadastrados: parseInt(cadastrados.asia || 0),
      nao_cadastrados: parseInt(naoCadastrados.asia || 0),
    },
  ]

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Status dos Produtos</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isLoading ? (
            <Flex justify="center" py={10}>
              <Spinner size="xl" color="blue.500" />
            </Flex>
          ) : (
            <>
              <Box mb={6}>
                <Heading size="md" mb={2}>
                  Totais Gerais
                </Heading>
                <Stack direction={['column', 'row']} spacing={4}>
                  <Box p={3} shadow="md" borderWidth="1px" flex="1" borderRadius="md">
                    <Text fontWeight="bold" color="green.600" fontSize="xl">
                      {totais.cadastrados || 0}
                    </Text>
                    <Text fontSize="sm">Cadastrados</Text>
                  </Box>
                  <Box p={3} shadow="md" borderWidth="1px" flex="1" borderRadius="md">
                    <Text fontWeight="bold" color="red.600" fontSize="xl">
                      {totais.nao_cadastrados || 0}
                    </Text>
                    <Text fontSize="sm">Não Cadastrados</Text>
                  </Box>
                  <Box p={3} shadow="md" borderWidth="1px" flex="1" borderRadius="md" bg="gray.50">
                    <Text fontWeight="bold" fontSize="xl">
                      {(totais.cadastrados || 0) + (totais.nao_cadastrados || 0)}
                    </Text>
                    <Text fontSize="sm">Total</Text>
                  </Box>
                </Stack>
              </Box>

              <Box overflowX="auto">
                <Table variant="simple" size="sm">
                  <Thead>
                    <Tr>
                      <Th>Fornecedor</Th>
                      <Th isNumeric>Cadastrados</Th>
                      <Th isNumeric>Não Cadastrados</Th>
                      <Th isNumeric>Total</Th>
                      <Th>Status</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {fornecedores.map((fornecedor) => {
                      // Calcula o total para este fornecedor
                      const total = fornecedor.cadastrados + fornecedor.nao_cadastrados

                      return (
                        <Tr key={fornecedor.id}>
                          <Td fontWeight="medium">{fornecedor.nome}</Td>
                          <Td isNumeric color="green.600">
                            {fornecedor.cadastrados}
                          </Td>
                          <Td isNumeric color="red.600">
                            {fornecedor.nao_cadastrados}
                          </Td>
                          <Td isNumeric>{total}</Td>
                          <Td>
                            <Badge
                              colorScheme={
                                fornecedor.cadastrados === 0 && fornecedor.nao_cadastrados > 0
                                  ? 'red'
                                  : fornecedor.nao_cadastrados === 0 && fornecedor.cadastrados > 0
                                    ? 'green'
                                    : total > 0
                                      ? 'yellow'
                                      : 'gray'
                              }
                            >
                              {fornecedor.cadastrados === 0 && fornecedor.nao_cadastrados > 0
                                ? 'Pendente'
                                : fornecedor.nao_cadastrados === 0 && fornecedor.cadastrados > 0
                                  ? 'Completo'
                                  : total > 0
                                    ? 'Parcial'
                                    : 'Sem dados'}
                            </Badge>
                          </Td>
                        </Tr>
                      )
                    })}
                  </Tbody>
                </Table>
              </Box>
            </>
          )}
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" onClick={onClose}>
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ModalStatus
